import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60aedf05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "k-window k-dialog",
  role: "dialog"
}
const _hoisted_3 = { class: "k-window-titlebar k-dialog-titlebar" }
const _hoisted_4 = { class: "k-window-title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "k-window-actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "presentation",
  class: "k-icon k-button-icon k-i-x"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "m-container" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "k-content" }
const _hoisted_12 = { class: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.errorDialogParameter.isError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["k-dialog-wrapper", _ctx.sizing]),
          tabindex: "0"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  innerHTML: _ctx.getTitle()
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "k-button k-button-md k-rounded-md k-icon-button k-button-flat k-button-flat-base k-window-action k-dialog-action",
                  "aria-label": "Close",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.applyOk()), ["prevent"]))
                }, _hoisted_8)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                innerHTML: _ctx.getText(),
                class: "m-content"
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", _hoisted_12, [
                _createElementVNode("span", {
                  class: "k-button-text",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.applyOk()), ["prevent"]))
                }, "Schliessen")
              ])
            ])
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}